
import React from "react";

import { NavItem, NavLink, Nav, Container, Row, Col, NavbarBrand } from "reactstrap";
import { useTranslation } from '../../i18n/context';

function AuthFooter() {
  const { t } = useTranslation();
  return (
    <>
      <footer className="py-5" id="footer-main">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            <Col xl="6">
              <NavbarBrand to="/">
                <img
                  alt="aloPay"
                  src={require("assets/img/brand/alo pay 1 (1).png")}
                  style={{ height: "65px" }}
                />
              </NavbarBrand>
            </Col>
            <Col xl="6">

              <div className="copyright text-center text-xl-left text-muted">
                © {new Date().getFullYear()}{" "}

                <b> aloPay</b> • All Rights Reserved

              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default AuthFooter;
